import { DataTypeLti } from '@efdigital/ll-admin-v2/data/data-types/lti';
import type { JsonApiDocument } from '@efdigital/ll-admin-v2/data/normalizers/jsonapi-document';
import type {
  ConsumedToolDeployment,
  ConsumedToolDeploymentListResponse,
} from '@efdigital/ll-cdk-lti-registration-api-types';

export function consumedToolDeploymentToJsonApiResource(
  deployment: ConsumedToolDeployment
) {
  return {
    type: DataTypeLti.ConsumedToolDeployment,
    id: deployment.id,
    attributes: {
      consumedToolId: deployment.consumedToolId,
      platformDeploymentId: deployment.platformDeploymentId,
      resourceLinkClaimPath: deployment.resourceLinkClaimPath,
      isActive: deployment.isActive,
      createdAt: deployment.createdAt,
      updatedAt: deployment.updatedAt,
    },
  };
}

export function consumedToolDeploymentToJsonApiDocument(
  deployment: ConsumedToolDeployment
): JsonApiDocument {
  return {
    data: consumedToolDeploymentToJsonApiResource(deployment),
  };
}

export function listConsumedToolDeploymentsResponseToJsonApiDocument(
  response: ConsumedToolDeploymentListResponse
): JsonApiDocument {
  return {
    data: response.map(consumedToolDeploymentToJsonApiResource),
  };
}
